<div>
    <ng-container [ngTemplateOutlet]="bodyContent"></ng-container>
</div>